// extracted by mini-css-extract-plugin
module.exports = {"myBtn":"MyButton_myBtn__1Q00n"};